import { Box, Grid2 } from '@mui/material';
import { Link } from 'react-router-dom';
import { calculateCreatedAgo } from '../../../components/commonFunc';
import { getHubItemHref, isExternalHubHref } from '../helper/hubItemHref';
import { ListingCardImage } from './ListingCardImage';

const featuredLinkClassName = 'block no-underline text-inherit cursor-pointer';

export const HubFeatureCard = ({ firstBlog, to }) => {
  const href = to ?? getHubItemHref(firstBlog);

  const content = (
    <Grid2 container spacing={2}>
      <Grid2
        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
        className="relative text-start text-white px-6 rounded-2xl min-h-[300px]"
        display="flex"
        flexDirection="column"
        justifyContent="end"
        alignItems="flex-start"
      >
        <div className="relative w-full h-full">
          <ListingCardImage
            mediaPath={firstBlog?.postMedia}
            title={firstBlog?.title}
            postType={firstBlog?.postType}
            containerClassName="w-full aspect-[800/400] rounded-2xl"
            imageClassName="w-full aspect-[800/400] rounded-2xl object-cover"
            fallbackTitleClassName="line-clamp-4 text-2xl font-medium leading-snug text-[#021744] md:text-3xl"
            showFallbackLabel={false}
            showFallbackTitle={false}
          />

          <Box
            sx={{ background: 'linear-gradient(0deg, #22c0b1, #22c0b1, #ffffff00)' }}
            className="absolute bottom-0 w-full p-6 rounded-b-2xl"
          >
            <h4 className="cursor-pointer text-[42px] leading-[54.6px] font-medium">
              {firstBlog?.title}
            </h4>
            <Box className="cursor-pointer w-full py-3" display="flex" gap={6}>
              <span>{calculateCreatedAgo(firstBlog)}</span>
              <span>By Charlee.ai</span>
            </Box>
          </Box>
        </div>
      </Grid2>
      <Grid2 size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
        <p className="line-clamp-[12]">{firstBlog?.content}</p>
      </Grid2>
    </Grid2>
  );

  if (!href) {
    return content;
  }

  if (isExternalHubHref(href)) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={featuredLinkClassName}
      >
        {content}
      </a>
    );
  }

  return (
    <Link to={href} className={featuredLinkClassName}>
      {content}
    </Link>
  );
};
